import { render, staticRenderFns } from "./phoneShow.vue?vue&type=template&id=bd8b65e6&scoped=true&"
import script from "./phoneShow.vue?vue&type=script&lang=js&"
export * from "./phoneShow.vue?vue&type=script&lang=js&"
import style0 from "./phoneShow.vue?vue&type=style&index=0&id=bd8b65e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8b65e6",
  null
  
)

export default component.exports